module.exports = __webpack_public_path__ + "static/image5@2x-da9ff2cceb6f8e4187ded380a2a7dd76.png";